import { AppBar, Toolbar, IconButton, Typography, Box, Button } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useThemeMode } from "@context/ThemeContext";
import { useLanguageToggle } from "@hooks/useLanguageToggle";
import { AppMark } from "@components/AppMark";

interface TopBarProps {
  onMenuClick: () => void;
}

export function TopBar({ onMenuClick }: TopBarProps) {
  const { mode, toggleTheme } = useThemeMode();
  const { language, toggleLanguage } = useLanguageToggle();

  return (
    <AppBar
      position="fixed"
      color="inherit"
      elevation={0}
      sx={{
        display: { lg: "none" },
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Toolbar>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
          <AppMark size={28} fontSize={12} borderRadius={1.5} />
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
            }}
          >
            1Time Upload
          </Typography>
        </Box>
        <Button size="small" onClick={toggleLanguage} sx={{ minWidth: 40 }}>
          {language.toUpperCase()}
        </Button>
        <IconButton onClick={toggleTheme} size="small">
          {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
        </IconButton>
        <IconButton edge="end" onClick={onMenuClick}>
          <MenuIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}
